import { Settings } from '../Settings.js';
import { frameBudgetExhausted } from './FrameBudget.js';

let pending = [];
let pendingIndex = 0;

export const queueBreak = object => {
	if(!object || object.destroyed || object.prefabObject.destroyed || object.breakQueued) return false;
	object.breakQueued = true;
	pending.push(object);
	return true;
};

export const update = () => {
	const started = performance.now();
	let processed = 0;
	let examined = 0;
	while(pendingIndex < pending.length && processed < Settings.maxSoftBreaksPerFrame){
		if(frameBudgetExhausted('softBreaks', started, Settings.maxSoftBreakProcessingTimeMS, examined)) break;
		const object = pending[pendingIndex++];
		examined++;
		object.breakQueued = false;
		if(object.destroyed || object.prefabObject.destroyed || !object.prefabObject.settings.isDestructible) continue;
		object.break();
		processed++;
	}
	if(pendingIndex === pending.length){
		pending.length = 0;
		pendingIndex = 0;
	}else if(pendingIndex > 256){
		pending = pending.slice(pendingIndex);
		pendingIndex = 0;
	}
	return processed;
};

export const reset = () => {
	for(let i = pendingIndex; i < pending.length; i++) pending[i].breakQueued = false;
	pending.length = 0;
	pendingIndex = 0;
};

export const getPendingBreakCount = () => pending.length - pendingIndex;
